import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  errorMessage,
  enterpriseUpdateBillingCycle,
} from '@features/payments';
import axiosInstance from '@server/axiosInstance';
import { profileKey } from '@staffedupusa/shared-components';

type useUpdateEnterpriseBillingCycleProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  onSuccess?: () => void;
};

export const useUpdateEnterpriseBillingCycle = ({
  setErrorText = () => { },
  onSuccess = () => { },
}: useUpdateEnterpriseBillingCycleProps) => {
  const client = useQueryClient();

  const { mutate: updateBillingCycle, isLoading: isUpdatinBillingCycle } =
    useMutation({
      mutationFn: (variables: { billing_cycle: number }) =>
        axiosInstance
          .post(enterpriseUpdateBillingCycle, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          onSuccess();
          client.invalidateQueries([profileKey]);
        }
      },
      onError: () => setErrorText(errorMessage),
    });

  return {
    updateBillingCycle,
    isUpdatinBillingCycle,
  };
};
